import * as React from 'react';
export var headingSectionIndexContext = React.createContext(0);
